import React, { useRef } from "react";
import photoAlbum from "../../assets/photo-album.svg";
interface ThumbnailUploadProps {
    value: string;
    preview: string;
    file: File | null;
    onChange: (file: File, preview: string) => void;
    onRemove: () => void;
    onBlur?: () => void;
    touched?: boolean;
    error?: string;
}

const ThumbnailUpload: React.FC<ThumbnailUploadProps> = ({
    preview,
    file,
    onChange,
    onRemove,
    onBlur,
    touched = false,
    error
}) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files?.[0];
        if (selectedFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
                onChange(selectedFile, reader.result as string);
            };
            reader.readAsDataURL(selectedFile);
        }
    };

    const handleBrowseClick = () => {
        fileInputRef.current?.click();
    };

    return (
        <div>
            <label className="block text-base font-light text-white text-light mb-4">
                Project Thumbnail
            </label>
            <div className="space-y-3 lg:space-y-6">
                <div className="relative">
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        className="hidden"
                        id="thumbnail-upload"
                    />
                    <label
                        htmlFor="thumbnail-upload"
                        className={`flex flex-col bg-transparent max-w-[278px] min-h-[179px] items-center justify-center w-full h-32 border border-[#E761A0] rounded-[18px] cursor-pointer transition-all duration-200 overflow-hidden ${touched && error
                                ? 'border-red-500/50 bg-red-500/10'
                                : ' hover:border-white/30'
                            }`}
                    >
                        {preview ? (
                            <div className="relative w-full h-full min-h-[179px] p-2 flex items-center justify-center">
                                <img
                                    src={preview || undefined}
                                    alt="Thumbnail preview"
                                    className="w-full h-full object-contain rounded-lg"
                                />
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        onRemove();
                                    }}
                                    className="absolute top-2 right-2 p-1 bg-red-500/80 hover:bg-red-600 rounded-full text-white transition-colors"
                                >
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        ) : (
                            <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                <img src={photoAlbum} alt="Album" className="w-[74px] h-[74px] mb-3" />
                                <span className="text-gray-500 text-sm">Click or drop image</span>
                            </div>
                        )}
                    </label>
                </div>
                {file && (
                    <p className="text-sm text-gray-400">
                        Selected: <span className="text-white">{file.name}</span>
                    </p>
                )}
                <div className="flex w-full max-w-[549px] h-[53px] rounded-full border border-[#868686] overflow-hidden bg-transparent">
                    <button
                        type="button"
                        onClick={handleBrowseClick}
                        className="browse-file-btn shrink-0 px-9 h-full bg-white text-gray-800 text-base rounded-full font-semibold uppercase tracking-wide hover:bg-gray-100 transition-colors"
                    >
                        BROWSE FILE
                    </button>
                    <input
                        type="text"
                        readOnly
                        placeholder="No file chosen"
                        value={file?.name ?? (preview ? "Current thumbnail" : "")}
                        className="flex-1 min-w-0 h-full px-4 bg-transparent text-gray-400 text-sm placeholder-gray-500 focus:outline-none border-0"
                    />
                </div>
                {touched && error && (
                    <p className="text-sm text-red-400 flex items-center gap-1">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {error}
                    </p>
                )}
            </div>
        </div>
    );
};

export default ThumbnailUpload;





